import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import {
  ButtonSizeEnum,
  SecondaryButton,
} from 'src/editor/shared/ui-lib/buttons'
import { ChevronLeftIcon } from '../icons/chevron-left-icon'

interface BackButtonProps
  extends Omit<React.ComponentProps<typeof SecondaryButton>, 'children'> {
  children?: React.ReactNode
}

export const BackButton = ({ children, ...props }: BackButtonProps) => {
  const { t } = useTypedTranslation()
  return (
    <SecondaryButton
      size={ButtonSizeEnum.Small}
      iconBefore={<ChevronLeftIcon />}
      {...props}
    >
      {!children ? t('components.core.back_button') : children}
    </SecondaryButton>
  )
}
